<template>
  <update-business-member-field
    title="Gender"
    :value="capitalize(member.gender)"
    :member="member"
    :is-loading="isLoading"
    @update:isLoading="$emit('update:isLoading', $event)"
    :is-editing="isEditing"
    @update:isEditing="handleIsEditing"
    @save="save"
  >
    <base-select placeholder="Select gender" :options="genderOptions" label-key="name" v-model="gender" required />
  </update-business-member-field>
</template>

<script>
import UpdateBusinessMemberField from "@/views/business/member/components/UpdateBusinessMemberField";
import { capitalize } from "lodash";

export default {
  components: {
    UpdateBusinessMemberField,
  },
  props: {
    isLoading: Boolean,
    isEditing: Boolean,
    member: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      gender: "",
      genderOptions: [{ value: "male", name: "Male" }, { value: "female", name: "Female" }],
    };
  },
  methods: {
    capitalize,
    handleIsEditing($event) {
      this.gender = this.member.gender;
      this.$emit("update:isEditing", $event);
    },
    save() {
      this.$emit("updated", {
        ...this.member,
        gender: this.gender,
      });
    },
  },
};
</script>
